export default __webpack_public_path__ + "static/media/image-icon.85106894.svg";